<template>
  <default-layout class="home-view-container" :navId="2">
    <div class="ykxm-newsinformation-content">
      <div class="img"></div>
      <!-- 企业简介 start -->
      <Introduce  :anchor="anchor == 1"></Introduce>
      <!-- 企业简介 end -->
      <!-- 发展历程 start -->
      <Development  :anchor="anchor == 2"></Development>
      <!-- 发展历程 end -->
      <!-- 企业荣誉 start -->
      <Business  :anchor="anchor == 3"></Business>
      <!-- 企业荣誉 end -->
      <!-- 合作伙伴 start -->
      <!-- <Partner  :anchor="anchor == 4"></Partner> -->
      <!-- 合作伙伴 end -->
      <Footer  :anchor="anchor == 4"></Footer>
    </div>
  </default-layout>
</template>

<script setup>
import DefaultLayout from '@/layout/default.vue';
import Introduce from '@/components/introduce.vue';
import Development from '@/components/development.vue';
import Business from '@/components/business.vue';
// import Partner from '@/components/partner.vue';
import Footer from '@/components/footer.vue';

import { useRoute } from 'vue-router';
import { ref } from 'vue';

const route = useRoute();


const anchor = ref(route.query.anchor);

</script>

<style lang="scss" scoped>
.ykxm-newsinformation-content {
  width: 100%;
  font-size: 0;
  .img {
    width: 100%;
    height: 320px;
    background: url('~@/assets/img/ymxk-about-bg.png') no-repeat center center;
    background-size: cover;
  }
}
</style>
